import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { WipService } from 'app/modules/well-integrity-planning/services/wip.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PlanDateAction, PlanDateRequest, WIPType } from 'app/modules/well-integrity-planning/model';
import { debounceTime, take } from 'rxjs';
import module from "app/modules/well-integrity-planning/well-integrity-planning.module";

@Component({
    selector: 'app-plan-date',
    templateUrl: './plan-date.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: module,
    styleUrls: ['./plan-date.component.scss'],
})
export class PlanDateFormComponent {
    private optionSelectedFlag: boolean = false;
    wellStringName: string;
    isUpdate: boolean = false;
    type: string;

    payload: PlanDateRequest = {
        id: '',
        planDate: '',
        remark: '',
    };

    options = {
        wellStrings: [],
    };

    get isCreate() {
        const isCreate = [WIPType.adhoc];
        return isCreate.includes(this.data.type) && this.data.action == "create";
    }

    constructor(
        public dialogRef: MatDialogRef<PlanDateFormComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: { payload: PlanDateRequest; type: WIPType; action: PlanDateAction },
        private service: WipService
    ) { }

    ngOnInit() {
        Promise.resolve().then(() => {
            this.isUpdate = false;
            let { id, planDate, remark, wellStringId } = { ...this.data.payload };
            this.payload = { id, planDate, remark, wellStringId };
            this.type = this.data.type;
        });
    }

    onAutocomplete() {
        const value = this.wellStringName;
        if (!value) {
            this.payload.wellStringId = ''
            return
        };
        if (value.length < 3) return;
        this.service
            .getWellString({ wellstring: value })
            .pipe(debounceTime(300), take(1))
            .subscribe((res: any) => {
                this.options.wellStrings = res.data.wellStrings;

                // If not found
                if (this.options.wellStrings.length <= 0) {
                    this.options.wellStrings = [{
                        id: '',
                        stringShortName: 'Not Found',
                        stringLongName: 'Not Found',
                    }]
                }

                this.onSelected();
            });
    }

    onSelected() {
        const value = this.wellStringName;
        const result = this.options.wellStrings.filter((row: any) => {
            return (
                row.stringShortName.toLowerCase() ===
                value.toLowerCase()
            );
        });

        if (result.length != 1) {
            this.payload.wellStringId = null;
            return;
        }
        this.payload.wellStringId = result[0].id
        this.optionSelectedFlag = true;
        this.options.wellStrings = []
    }

    save() {
        const action = this.data.action == 'create' ? this.create() : this.update();
        action.pipe(take(1)).subscribe((response) => {
            this.isUpdate = true;
            this.closeDialog();
        });
    }

    create() {
        let { planDate, remark, wellStringId } = { ...this.payload };
        this.payload = { planDate, remark, wellStringId };
        switch (this.type) {
            case WIPType.adhoc:
                return this.service.createAdhoc(this.payload);
        }
    }

    update() {
        let { id, planDate, remark } = { ...this.payload };
        this.payload = { id, planDate, remark };
        switch (this.type) {
            case WIPType.pm:
                return this.service.updatePreventive(this.payload);
            case WIPType.wrsv:
                return this.service.updateWrsv(this.payload);
            case WIPType.apr:
                return this.service.updateApr(this.payload);
            case WIPType.cm:
                return this.service.updateCm(this.payload);
            case WIPType.adhoc:
                return this.service.updateAdhoc(this.payload);
        }
    }

    validateSelection() {
        // If user didn't pick from the list, clear input
        if (!this.optionSelectedFlag && !this.payload.wellStringId) {
            this.wellStringName = '';
        }

        this.optionSelectedFlag = false; // reset for next time
    }

    closeDialog(): void {
        this.dialogRef.close(this.isUpdate);
    }
}
